import { render, staticRenderFns } from "./VideoDirectorDetails.vue?vue&type=template&id=43d5b3d4&scoped=true&"
import script from "./VideoDirectorDetails.vue?vue&type=script&lang=js&"
export * from "./VideoDirectorDetails.vue?vue&type=script&lang=js&"
import style0 from "./VideoDirectorDetails.vue?vue&type=style&index=0&id=43d5b3d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d5b3d4",
  null
  
)

export default component.exports